var map = {
	"./actionadventure.svg": 876,
	"./comedy.svg": 877,
	"./crime.svg": 878,
	"./culturallife.svg": 879,
	"./drama.svg": 880,
	"./fairytale.svg": 881,
	"./fantasy.svg": 882,
	"./friendship.svg": 883,
	"./futureaspirations.svg": 884,
	"./history.svg": 885,
	"./holidays.svg": 886,
	"./horror.svg": 887,
	"./hover/actionadventure.svg": 360,
	"./hover/comedy.svg": 361,
	"./hover/crime.svg": 362,
	"./hover/culturallife.svg": 363,
	"./hover/drama.svg": 364,
	"./hover/fairytale.svg": 365,
	"./hover/fantasy.svg": 366,
	"./hover/friendship.svg": 367,
	"./hover/futureaspirations.svg": 368,
	"./hover/history.svg": 369,
	"./hover/holidays.svg": 370,
	"./hover/horror.svg": 371,
	"./hover/mystery.svg": 372,
	"./hover/religious.svg": 373,
	"./hover/reviews.svg": 374,
	"./hover/romance.svg": 375,
	"./hover/scifi.svg": 376,
	"./hover/tech.svg": 377,
	"./hover/thriller.svg": 378,
	"./mystery.svg": 888,
	"./religious.svg": 889,
	"./reviews.svg": 890,
	"./romance.svg": 891,
	"./scifi.svg": 892,
	"./tech.svg": 893,
	"./thriller.svg": 894
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 875;